// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__4Y7OB","subWrapper":"styles_subWrapper__Z+JWp","titleText":"styles_titleText__fvA2j","orderButton":"styles_orderButton__rRIvA","date":"styles_date__u4ppQ"};